import { Avatar, Badge, Divider, Popover, Tooltip } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { IoMdArrowDropdown } from 'react-icons/io'
import { IoIosNotifications } from 'react-icons/io'
import { IoMdArrowDropup } from 'react-icons/io'
import { MdMessage } from 'react-icons/md'
import CustomButton from 'components/atoms/custom-button'
import { Logo, NoImage } from 'assets'
import useAuth from 'hooks/useAuth'
import { RxHamburgerMenu } from 'react-icons/rx'
import { useSelector } from 'react-redux'
import { useUnreads, Session } from '@talkjs/react'
import useAdvisor from 'hooks/useAdvisor'
import { useQuery } from 'react-query'
import { getNotification } from 'api'
import NotificationContentCard from 'components/organisms/Card/NotificationContentCard'
import { TYPE_KEYS } from 'hooks/permissions/constant'
import { Config } from '../../utils/initialConfig'
import dayjs from 'dayjs'
import SmartLink from 'components/atoms/SmartLink'
import { notificationPathByMessage } from 'constant/notificationPathByMessage'
import { useClientWidth } from 'hooks/useClientWidth'

const navProfileList = [
  {
    name: 'Akun Saya',
    route: '/profile'
  }
  // { name: 'Transaksi', route: '/profile/transaction' },
  // { name: 'Penjualan', route: '/sales' },
  // { name: 'Pembelian', route: '/purchase' },
  // { name: 'Belangganan', route: '/subscription' }
]

const advisorPaths = [
  '/advisor',
  '/advisor/detail/:id',
  '/advisor/listings/advisor-profile',
  '/advisor/listings/verification'
]
const pricingPaths = [
  '/pricing/buyer',
  '/pricing/seller',
  '/pricing/advisor',
  '/pricing',
  '/addons'
]
const otherPaths = ['/blog', '/blog/:id/detail', '/about-tomazz', '/support', '/how-tomazz-works']
// New UI Navbar
const platformPaths = ['/buyer', '/buyer/detail/', '/seller', '/seller/detail/']
const communityPaths = [
  '/blog',
  '/events',
  '/press-release',
  '/knowledge-base',
  '/knowledge-base/detail'
]
const servicePaths = ['/services', '/events', '/valuation-tool']
const aliasPaths = {
  platform: platformPaths,
  community: communityPaths,
  pricing: pricingPaths,
  advisor: advisorPaths,
  other: otherPaths,
  services: servicePaths
}

function renderContentPopoverNavigation(menu, name) {
  return !['Lainnya', 'More']?.includes(name) ? (
    <div className="grid grid-cols-1 gap-2 items-center w-full">
      {menu.map((menuItem, index) => {
        const { name, isNextUrl } = menuItem
        return (
          <SmartLink
            isNextUrl={isNextUrl}
            href={menuItem?.route ?? ''}
            key={index}
            className="p-2 grid grid-cols-1 rounded gap-x-8 group cursor-pointer hover:bg-surface-primary-3">
            {/* Title & Desc */}
            <span
              className={`text-sm text-nowrap ${
                window.location.pathname.includes(menuItem?.route)
                  ? 'text-brand-default'
                  : 'text-primary'
              }`}>
              {name ?? ''}
            </span>
          </SmartLink>
        )
      })}
    </div>
  ) : (
    <ul className="list-none flex flex-col gap-1 w-full">
      {menu
        ?.filter((el) => el.isShow)
        .map((menuItem, index) => {
          return (
            <li key={index}>
              <SmartLink
                isNextUrl={menuItem.isNextUrl}
                className={`p-4 grid grid-cols-1 rounded gap-x-8 group cursor-pointer hover:bg-surface-primary-3`}
                href={menuItem?.route ?? ''}>
                <span className="text-primary text-sm text-nowrap">{menuItem.name}</span>
              </SmartLink>
            </li>
          )
        })}
    </ul>
  )
}
function renderContentPopoverNotification(listNotification, getListnotification) {
  return (
    <div className="w-[320px] h-[640px] rounded bg-white overflow-auto">
      <div className="w-full p-4">
        <label className="text-base font-medium text-primary">Notifikasi</label>
      </div>
      {listNotification.map((v, index) => {
        const href = notificationPathByMessage(v.type, v.source_id, v.source_table)
        return (
          <SmartLink isNextUrl={false} className="no-underline" href={href} key={index}>
            <NotificationContentCard
              key={index}
              type={v.type}
              title={v.title}
              dateTime={v ? dayjs(v?.created_at).format('HH:mm') : ''}
              sourceId={v?.source_id}
              message={v.description}
              onAction={v.onAction}
              isRead={v.is_read_flag}
              refetch={() => getListnotification.refetch()}
              id={v.id}
              source_table={v.source_table}
            />
          </SmartLink>
        )
      })}
    </div>
  )
}
function renderContentPopoverProfile(onLogout) {
  return (
    <ul className="flex flex-col gap-2 list-none">
      {navProfileList.map((navItem, index) => {
        return (
          <li
            className="w-[120px] py-[6px] px-3 cursor-pointer text-primary rounded hover:text-brand-default hover:bg-surface-primary-3"
            key={index}>
            <SmartLink
              isNextUrl={false}
              className="text-primary cursor-pointer h-full flex whitespace-nowrap"
              href={navItem?.route ?? ''}>
              {navItem.name}
            </SmartLink>
          </li>
        )
      })}
      <Divider
        variant="solid"
        className="m-0 border-solid border-t-0 border-[1.5px] border-lighter"
      />
      <span
        className="text-primary cursor-pointer h-full flex w-32 whitespace-nowrap px-3 py-2 rounded hover:bg-surface-primary-3"
        onClick={onLogout}>
        Keluar
      </span>
    </ul>
  )
}
const initialIsOpen = {
  isOpen: false,
  name: ''
}
const Header = () => {
  const navigate = useNavigate()
  const userData = useSelector((state) => state.auth)
  const [searchParams, setSearchParams] = useSearchParams()

  const { isUserAdvisor } = useAdvisor()
  const { pathname } = useLocation()
  const { userType } = useAuth()
  const width = useClientWidth()

  const findAliasByPathname = () => {
    const type = searchParams.get('type')

    if (pathname.includes('/events')) {
      if (type === 'WEBINAR') return 'services'
      if (type === 'CONNECT_DAYS') return 'community'
    }

    return (
      Object.entries(aliasPaths).find(([alias, paths]) =>
        paths.some((path) => {
          const basePath = path.replace(/:.*$/, '')
          return pathname.includes(basePath)
        })
      )?.[0] || null
    )
  }

  const navList = [
    {
      name: 'Platform',
      alias: 'platform',
      children: [
        {
          name: 'Untuk Pembeli & Investor',
          route: '/buyer',
          isShow: true,
          isNextUrl: true
        },
        {
          name: 'Untuk Penjual & Investasi',
          route: '/seller',
          isShow: true,
          isNextUrl: true
        },
        {
          name: 'Badges dan Validasi',
          route: '/badges',
          isShow: true,
          isNextUrl: true
        }
        // {
        //   name: 'Profil Pembeli',
        //   description: 'Buat Profil & Biarkan Penjual Menemukan Anda',
        //   route:
        //     userType === TYPE_KEYS.FREE
        //       ? '/buyer/buy-package'
        //       : `/${isUserAdvisor ? 'advisor' : 'buyer'}/listing/buy-company`,
        //   icon: QuickReferenceAllIcon,
        //   isShow: true
        // }
        // {
        //   name: 'Jadi Investor',
        //   description: 'Temukan Investasi di Perusahaan atau Konsep Bisnis yang Menjanjikan',
        //   route: '/investor',
        //   icon: IdentityPlatformIcon
        // },
        // {
        //   name: 'Temukan Waralaba',
        //   description:
        //     'Jelajahi Peluang Waralaba Terbukti yang Disesuaikan dengan Tujuan Investasi Anda',
        //   route: '/franchise',
        //   icon: CorporateFareIcon
        // }
      ]
    },
    {
      name: 'Partners',
      alias: 'advisor',
      children: [
        {
          name: 'Temukan Partner',
          route: '/advisor',
          isShow: true,
          isNextUrl: true
        },
        {
          name: 'Menjadi Partner',
          route:
            userType === TYPE_KEYS.FREE || !isUserAdvisor
              ? '/pricing'
              : `/profile/advisor-information`,
          isNextUrl: userType === TYPE_KEYS.FREE || !isUserAdvisor ? true : false,
          isShow: true
        }
      ]
    },
    {
      name: 'Layanan',
      alias: 'services',
      route: '/services',
      children: [
        {
          name: 'Layanan',
          route: '/services',
          isShow: true,
          isNextUrl: true
        },
        {
          name: 'Webinars',
          route: '/events?type=WEBINAR',
          isShow: true,
          isNextUrl: true
        },
        {
          name: 'Alat Valuasi',
          route: '/valuation-tool',
          isNextUrl: true,
          isShow: userType !== undefined
        }
      ]
    },
    {
      name: 'Komunitas',
      alias: 'community',
      children: [
        {
          name: 'Connect Days',
          route: '/events?type=CONNECT_DAYS',
          isShow: true,
          isNextUrl: true
        },

        {
          name: 'Blog',
          route: '/blog',
          isShow: true,
          isNextUrl: true
        },
        {
          name: 'Knowledge Based',
          route: '/knowledge-base',
          isShow: true,
          isNextUrl: true
        },
        {
          name: 'Press Release',
          route: '/press-release',
          isNextUrl: true
        }
      ]
    },
    {
      name: 'Plan & Pricing',
      alias: 'pricing',
      route: '/pricing',
      isNextUrl: true
    },
    // {
    //   name: 'Plan & Pricing',
    //   alias: 'pricing',
    //   children: [
    //     {
    //       name: 'Plans',
    //       route: '/pricing',
    //       isNextUrl: false
    //     },
    //     {
    //       name: 'Addons',
    //       route: '/',
    //       isShow: true
    //     }
    //   ]
    // },
    {
      name: 'Lainnya',
      alias: 'other',
      children: [
        {
          name: 'How Tomazz Works',
          route: '/how-tomazz-works',
          isShow: true,
          isNextUrl: true
        },
        {
          name: 'Tentang Tomazz',
          route: '/about-tomazz',
          isShow: true,
          isNextUrl: true
        },
        {
          name: 'Bantuan',
          route: '/support',
          isShow: true,
          isNextUrl: true
        }
      ]
    }
  ]

  const profile = userData?.profile
  const headerRef = useRef(null)
  const { getAccessToken, onLogout, userProfile } = useAuth()
  const [isOpen, setIsOpen] = useState({ ...initialIsOpen })
  const [isOpenMenu, setIsOpenMenu] = useState(false)
  const [selectedMenu, setSelectedMenu] = useState('')
  const [listNotification, setListNotification] = useState([])
  const [unreadNotif, setUnreadNotif] = useState(0)

  function onChangeOpen(val, name) {
    return setIsOpen((prev) => ({ ...prev, isOpen: val, name: name }))
  }
  const handleOpenMenu = () => setIsOpenMenu((prev) => !prev)
  const handleChangeSelected = (selected) => {
    setSelectedMenu((prev) => {
      if (prev === selected) return ''
      return selected
    })
  }

  useEffect(() => {
    if (width >= 1024 || pathname) {
      setIsOpenMenu(false)
      handleChangeSelected('')
    }
  }, [pathname, width])

  const getListnotification = useQuery({
    queryKey: ['getListNotification'],
    queryFn: () => getNotification(),
    enabled: !!getAccessToken(),
    onSuccess: ({ data }) => {
      setListNotification(data.data)
      setUnreadNotif(data?.meta?.total_unread)
    },
    onError: () => {}
  })

  return (
    <header className="sticky top-0 z-[200] bg-white" ref={headerRef}>
      <Session appId={Config.REACT_APP_TALKJS_ID} userId={profile?.email ?? 'sample_user_alice'}>
        {/* ✅ sr-only headings untuk SEO & a11y */}
        <h2 className="sr-only">Jual Bisnis Anda Sekarang</h2>
        <h3 className="sr-only">Listing Terverifikasi & Aman</h3>
        <h3 className="sr-only">Jual Bisnis UMKM & Korporasi</h3>

        <h2 className="sr-only">Temukan Bisnis untuk Dibeli</h2>
        <h3 className="sr-only">Peluang Investasi Bisnis Siap Jalan</h3>
        <h3 className="sr-only">Bisnis Terbaik untuk Dibeli di Indonesia</h3>

        <h2 className="sr-only">Bergabung Sebagai Partner M&A</h2>
        <h3 className="sr-only">Partner Profesional Marketplace M&A</h3>
        <h3 className="sr-only">Ekosistem Partner Tomazz</h3>

        <h2 className="sr-only">Knowledge Base & Blog</h2>
        <h3 className="sr-only">Panduan Lengkap Jual Beli Bisnis</h3>
        <h3 className="sr-only">Wawasan & Tren M&A Indonesia</h3>

        <h2 className="sr-only">Hubungi Kami</h2>
        <h3 className="sr-only">Konsultasi Gratis Jual Beli Bisnis</h3>
        <h3 className="sr-only">Support & Kemitraan Tomazz</h3>
        <div className="mx-auto flex w-full max-w-[1920px] items-center justify-between bg-white p-4 lg:px-10 xl:px-[156px]">
          <div className="flex gap-6">
            <div className="flex gap-1 md:gap-x-4 items-center">
              <RxHamburgerMenu
                className="block xl:hidden h-6 w-6"
                onClick={() => handleOpenMenu(true)}
              />
              <SmartLink isNextUrl={true} className="cursor-pointers w-fit" href={'/'}>
                <Logo className="h-6 md:h-8" />
              </SmartLink>
            </div>
            <div className="hidden xl:flex gap-1 md:gap-4 xl:gap-6 mt-2">
              {navList.map((navItem, index) => {
                return navItem?.children?.length > 0 ? (
                  <Popover
                    placement="bottomLeft"
                    onOpenChange={(val) => {
                      onChangeOpen(val, navItem.name)
                    }}
                    content={() => renderContentPopoverNavigation(navItem.children, navItem.name)}
                    arrow={false}
                    key={index}>
                    <span
                      className={`flex gap-1 flex-nowrap text-nowrap cursor-pointer ${
                        findAliasByPathname() === navItem.alias
                          ? 'text-brand-default'
                          : 'text-primary'
                      } hover:text-brand-default ${
                        isOpen.name === navItem.name && isOpen.isOpen ? 'text-brand-default' : ''
                      }`}>
                      {navItem.name}{' '}
                      {isOpen.name === navItem.name && isOpen.isOpen ? (
                        <IoMdArrowDropup size={20} className="fill-brand-default " />
                      ) : (
                        <IoMdArrowDropdown size={20} className="hover:fill-brand-default" />
                      )}
                    </span>
                  </Popover>
                ) : (
                  <SmartLink
                    isNextUrl={navItem.isNextUrl ?? false}
                    className={`no-underline w-max hover:text-brand-default ${
                      findAliasByPathname() === navItem.alias
                        ? 'text-brand-default'
                        : 'text-primary'
                    }`}
                    key={index}
                    href={navItem?.route}>
                    {navItem.name}
                  </SmartLink>
                )
              })}
            </div>
          </div>
          <div className="flex items-center w-full justify-end gap-6">
            {getAccessToken() ? (
              <div className="flex items-center gap-4 lg:gap-8">
                {/* Notif */}
                <Tooltip title="Notifikasi" placement="bottom">
                  <Popover
                     content={() =>
                     renderContentPopoverNotification(listNotification, getListnotification)
                     }
                     trigger="click"
                     styles={{
                     body: {
                        padding: 0
                     }
                     }}
                     arrow={false}>
                     <Badge count={unreadNotif}>
                     <IoIosNotifications className="cursor-pointer" size={24} />
                     </Badge>
                  </Popover>
                </Tooltip>
                {/* Message */}
                <UnreadConversationsCounter navigate={navigate} />
                <Popover
                  content={() => renderContentPopoverProfile(onLogout)}
                  trigger="click"
                  arrow={false}>
                  <div className="flex gap-1 items-center cursor-pointer">
                    <Avatar src={userProfile?.tmp_photo_profile || NoImage} alt="photo profile" />
                    <div className="hidden lg:flex flex-col">
                      <span className="text-primary text-sm font-medium leading-5">
                        {userProfile?.name ?? '-'}
                      </span>
                      {/* Akun Premi / Gratis */}
                      {userProfile?.user_type === 'FREE' ? (
                        <span className="text-secondary text-xs leading-4">Akun Gratis</span>
                      ) : (
                        <span className="text-brand-default text-xs leading-4">Akun Member</span>
                      )}
                    </div>
                    <IoMdArrowDropdown className="sm:block hidden" size={20} />
                  </div>
                </Popover>
              </div>
            ) : (
              <>
                <SmartLink
                  href={'/login'}
                  isNextUrl={false}
                  className="cursor-pointer no-underline text-primary font-medium hover:text-brand-default">
                  Masuk
                </SmartLink>
                <CustomButton
                  className="py-2 hidden sm:block "
                  onClick={() => navigate('/register')}>
                  Buat Akun
                </CustomButton>
              </>
            )}
          </div>
        </div>

        {/* MOBILE NAVBAR */}
        {isOpenMenu && (
          <>
            {/* Backdrop buat handle ketika Mobile Navbar diklik outside akan menutup menu */}
            <div
              className="fixed inset-0 z-[199] bg-black/0 xl:hidden"
              onClick={() => setIsOpenMenu(false)}
            />
            <div className="fixed left-0 top-0 z-[200] mt-[59px] w-full bg-white p-4 duration-500 ease-in md:mt-[68px] xl:hidden">
              <div className="flex flex-col gap-y-4 p-4">
                {navList.map((navItem, index) => {
                  return navItem?.children?.length > 0 ? (
                    <div className="flex w-full flex-col gap-1" key={index}>
                      <span
                        className={`flex cursor-pointer gap-1 px-4 py-[6px] text-sm font-medium hover:text-brand-default ${
                          selectedMenu === navItem.name || findAliasByPathname() === navItem.alias
                            ? 'text-brand-default'
                            : ''
                        }`}
                        onClick={() => handleChangeSelected(navItem.name)}>
                        {navItem.name}{' '}
                        {selectedMenu === navItem.name ? (
                          <IoMdArrowDropup size={20} className="fill-brand-default " />
                        ) : (
                          <IoMdArrowDropdown size={20} className="hover:fill-brand-default" />
                        )}
                      </span>
                      {selectedMenu === navItem.name &&
                        navItem.children.map(({ name, icon: Icon, route, isNextUrl }, index) => (
                          <SmartLink
                            isNextUrl={isNextUrl}
                            className="flex gap-4 py-2 pl-6 pr-4 text-sm no-underline"
                            href={route ?? ''}
                            key={index}>
                            {Icon && (
                              <div className="flex size-10 shrink-0 grow-0 items-center justify-center rounded-full bg-surface-primary-3">
                                <Icon className={'group-hover:fill-brand-default'} />
                              </div>
                            )}
                            <div className="flex flex-col gap-1">
                              <span
                                className={`font-medium leading-3  ${
                                  window.location.pathname.includes(route)
                                    ? 'text-brand-default'
                                    : 'text-primary'
                                }`}>
                                {name ?? ''}
                              </span>
                            </div>
                          </SmartLink>
                        ))}
                    </div>
                  ) : (
                    <SmartLink
                      isNextUrl={navItem.isNextUrl ?? false}
                      className="px-4 py-[6px] text-sm font-medium text-primary no-underline hover:text-brand-default"
                      key={index}
                      href={navItem?.route}>
                      {navItem.name}
                    </SmartLink>
                  )
                })}
              </div>
            </div>
          </>
        )}
      </Session>
    </header>
  )
}

function UnreadConversationsCounter({ navigate }) {
  const unreads = useUnreads()

  if (unreads === undefined) {
    return (
      <Tooltip title="Pesan" placement="bottom">
         <Popover trigger="click" arrow={false}>
            <SmartLink isNextUrl={false} href={'/profile/message'}>
               <button className="bg-white border-0">
                  <Badge count={0}>
                  <MdMessage size={24} className="cursor-pointer ml-3 lg:ml-0" />
                  </Badge>
               </button>
            </SmartLink>
            </Popover>
      </Tooltip>
    )
  }

  const unreadCount = unreads.length
  return (
   <Tooltip title="Pesan" placement="bottom">
      <Popover trigger="click" arrow={false}>
         <SmartLink isNextUrl={false} href={'/profile/message'}>
         <button className="bg-white border-0">
            <Badge count={unreadCount}>
               <MdMessage size={24} className="cursor-pointer ml-3 lg:ml-0" />
            </Badge>
         </button>
         </SmartLink>
      </Popover>
   </Tooltip>
  )
}

export default Header
